import React, { ReactElement, useContext } from 'react';
import { FormsContext } from '../../context/FormsContext';
import DefaultFields from './DefaultFields';
import Question from './Question';

const FormsPreview = (): ReactElement => {
  const { questions } = useContext(FormsContext);

  const renderQuestions = (): ReactElement | ReactElement[] => {
    if (questions.length === 0) {
      return <div></div>;
    } else {
      return questions.map((question, index) => {
        return (
          <div key={`render_questions_preview_${index}`}>
            <Question question={{ ...question, index }} />
          </div>
        );
      });
    }
  };

  return (
    <>
      <DefaultFields />
      {renderQuestions()}
    </>
  );
};

export default FormsPreview;
